import { Component, OnInit, OnDestroy, ViewEncapsulation, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { MessagesService } from './messages.service';
import { NotificationService } from 'src/app/pages/Notification/notification.service';
import { Notification } from 'src/app/pages/Notification/notification.model';
import { Settings } from 'src/app/app.settings.model';
import { AppSettings } from 'src/app/app.settings';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AuthLayoutComponent } from 'src/app/shared-component/auth-layout/auth-layout.component';
import * as signalR from '@microsoft/signalr';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [MessagesService],
  standalone: false
})
export class MessagesComponent implements OnInit, OnDestroy {
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  public selectedTab: number = 1;

  public files: Array<Object>;
  public meetings: Array<Object>;

  public settings: Settings;
  notifications: Notification[] = [];
  currentDate;
  notificationsPageIndex: number = 0;
  notificationsTotalRows: number = 0;
  notificationsCount: number = 0;
  pageSize = 10;
  isLoading = false;
  isLoadingMore = false;
  private notificationHub: signalR.HubConnection;
  constructor(private messagesService: MessagesService,
    public appSettings: AppSettings,
    public notificationService: NotificationService,
    private authLayout: AuthLayoutComponent,
    private translate: TranslateService,
    private route: Router,
    private _snackBar: MatSnackBar) {
    this.settings = this.appSettings.settings;
    this.files = messagesService.getFiles();
    this.meetings = messagesService.getMeetings();
  }

  ngOnInit() {
    this.currentDate = new Date();
    this.getNotificationsCount(true);
    const profileId = localStorage.getItem('currentProfileId');
    if (profileId && profileId !== 'undefined' && profileId !== 'null' && profileId.trim() !== '') {
      this.notificationHub = new signalR.HubConnectionBuilder()
        .configureLogging(signalR.LogLevel.Information)
        .withUrl(environment.notificationSignalRUrl, {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets
        })
        .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
        .build();

      this.notificationHub.start().then(() => {
        if (this.notificationHub.state === signalR.HubConnectionState.Connected) {
          this.notificationHub.invoke('login', profileId).catch(err => console.error('Error invoking login:', err));
        }
      }).catch(err => console.error('Error starting NotificationHub:', err?.toString?.() || err));

      this.notificationHub.onreconnected(() => {
        if (this.notificationHub.state === signalR.HubConnectionState.Connected) {
          this.notificationHub.invoke('login', profileId).catch(err => console.error('Error re-invoking login:', err));
        }
      });

      this.notificationHub.on('ReceiveNotification', () => {
        this.getNotificationsCount(true);
      });
    }
  }

  ngOnDestroy(): void {
    if (this.notificationHub) {
      this.notificationHub.off('ReceiveNotification');
      this.notificationHub.stop().catch(err => console.error(err));
    }
  }

  getNotificationsCount(refreshList: boolean = true) {
    this.notificationService.getNotificationsCount().subscribe({
      next: (result) => {
        this.notificationsCount = result;
      },
      error: (err) => console.error('Error fetching notifications count:', err)
    });
    if (refreshList) {
      this.getNotifications();
    }
  }

  getNotifications() {
    this.notificationsPageIndex = 1;
    this.isLoading = true;
    this.notificationService.getNotifications(this.notificationsPageIndex, this.pageSize).subscribe({
      next: (result) => {
        this.isLoading = false;
        if (result != null) {
          this.notifications = result.list || [];
          this.notificationsTotalRows = result.totalRows || 0;
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error fetching notifications:', err);
      }
    });
  }

  loadMore(event?: MouseEvent) {
    if (event) {
      this.stopClickPropagate(event);
    }
    if (this.isLoadingMore || this.isLoading || this.notifications.length >= this.notificationsTotalRows) {
      return;
    }
    this.isLoadingMore = true;
    const nextPage = this.notificationsPageIndex + 1;
    this.notificationService.getNotifications(nextPage, this.pageSize).subscribe({
      next: (result) => {
        this.isLoadingMore = false;
        if (result && result.list && result.list.length > 0) {
          this.notificationsPageIndex = nextPage;
          this.notificationsTotalRows = result.totalRows || this.notificationsTotalRows;
          const existingIds = new Set(this.notifications.map(n => n.id));
          const newItems = result.list.filter(n => !existingIds.has(n.id));
          this.notifications = [...this.notifications, ...newItems];
        }
      },
      error: (err) => {
        this.isLoadingMore = false;
        console.error('Error loading more notifications:', err);
      }
    });
  }

  dismissNotification(notification, event: MouseEvent) {
    event.stopPropagation(); // Prevent click event from reaching the parent button

    this.notificationService.dismissNotification(notification.id).subscribe(result => {
      if (result) {
        this._snackBar.open(this.translate.instant('Notification dismissed successfully'), null, {
          duration: 2000
        });
        this.notifications = this.notifications.filter(n => n.id !== notification.id);
        if (this.notificationsTotalRows > 0) {
          this.notificationsTotalRows--;
        }
        this.getNotificationsCount(false);
      }
    });
  }

  markNotificationAsRead(notification) {
    this.notificationService.markNotificationAsRead(notification.id).subscribe(result => {
      if (result) {
        if (!notification.isRead)
          this._snackBar.open(this.translate.instant('Notification marked as read successfully'), null, {
            duration: 2000
          });
      }
      notification.isRead = true;
      this.getNotificationsCount(false);
      this.authLayout.sidenav.open();
      if (notification.link) {
        location.href = notification.link;
      }
    });
  }


  calculateTimeDifference(sentDateStr: string): string {
    const sentDate = this.convertUTCDateToLocalDate(new Date(sentDateStr));
    const currentDate = new Date();
    const timeDifference = currentDate.getTime() - sentDate.getTime();

    const minutes = Math.floor(timeDifference / (1000 * 60)) % 60;
    const hours = Math.floor(timeDifference / (1000 * 60 * 60)) % 24;
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    if (days > 0) {
      return `${days} ${days === 1 ? this.translate.instant('day') : this.translate.instant('days')}`;
    } else {
      return `${hours} ${this.translate.instant('hours')}, ${minutes} ${this.translate.instant('minutes')}`;
    }
  }

  convertUTCDateToLocalDate(date) {
    var utc = new Date(date);
    var offset = utc.getTimezoneOffset();
    var newDate = new Date(utc.getTime() - offset * 60000);
    return newDate;
  }

  onMessagesMenuOpened() {
    this.getNotificationsCount(true);
    this.selectedTab = 0;
  }

  onMouseLeave() {
    this.trigger.closeMenu();
  }

  stopClickPropagate(event: any) {
    event.stopPropagation();
    event.preventDefault();
  }

  trackById(index: number, item: any) {
    return item.id;
  }

  /** Shown on the bell badge (capped for layout). */
  get badgeCountLabel(): string {
    const n = this.notificationsCount;
    if (n > 99) {
      return '99+';
    }
    return String(n);
  }

}
